import { z } from "zod";
import { Timestamps } from "../common/index.ts";
import { CustomerId } from "../fsm/fsm.schema.ts";
import {
  AppPermission,
  SupportedLanguageSchema,
  UserRole,
} from "./auth.schema.ts";
import { PermissionRule } from "./rbac.schema.ts";

export const User = z
  .object({
    id: z.string().uuid(),
    email: z.string().email(),
    name: z.string(),
    role: UserRole,
    customerIds: z.array(CustomerId),
    entityIds: z.array(z.string().uuid()).optional(),
    permissions: z.array(AppPermission).default([]),
    permissionRules: z.array(PermissionRule).optional(),
    preferredLanguage: SupportedLanguageSchema.default("en"),
    // Platform-plane authority (ADR-035). NOT NULL boolean in the DB
    // (auth_profiles.platform_admin DEFAULT false); default here keeps parse
    // fail-closed if a producer omits it.
    platformAdmin: z.boolean().default(false),
  })
  .merge(Timestamps);

export type User = z.infer<typeof User>;
